<template>
  <div>
    <v-card>
      <v-card-title>
        <v-img src="final.png" contain/>
        <!--v-avatar size="80">
          <v-img src="banner.png"/>
        </v-avatar-->
      </v-card-title>
      <v-card-text>
        <RegisterComponent/>
      </v-card-text>
      
    
    </v-card>
  </div>
  
</template>

<script>
import RegisterComponent from '../components/RegisterComponent.vue';
export default {
    components: { RegisterComponent }
}
</script>

<style scoped>
</style>